import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Terms from "./virtualtips/terms/Terms";
import Privacy from "./virtualtips/privacy/Privacy";
import Legal from "./virtualtips/legal/Legal";
import LoginOnboard from "./virtualtips/login/LoginOnboard";
import ForgotPassword from "./virtualtips/login/ForgotPassword";
import ResetPassword from "./virtualtips/login/ResetPassword";
import LandingStage from "./virtualtips/landing/LandingStage";
import LandingBuyVT from "./virtualtips/landing/LandingBuyVT";
import LandingUserTipHistory from "./virtualtips/landing/LandingUserTipHistory";
import LandingUserCode from "./virtualtips/landing/LandingUserCode";
import LandingUserBuyVTHistory from "./virtualtips/landing/LandingUserBuyVTHistory";
import Signup from "./virtualtips/signup/Signup";
import ValidateEmail from "./virtualtips/signup/ValidateEmail";
import LoginVenueUser from "./virtualtips/loginvenueuser/LoginVenueUser";
import App from "./App";
import ForgotPasswordVenue from "./virtualtips/loginvenueuser/ForgotPasswordVenue";
import MarketingHome from "./virtualtips/marketing/MarketingHome";
import SignupMobile from "./virtualtips/signup/mobile/SignupMobile";
import ValidateMobile from "./virtualtips/signup/mobile/ValidateMobile";
import LoginMobile from "./virtualtips/login/mobile/LoginMobile";
import LandingBuyDance from "./virtualtips/landing/LandingBuyDance";
import LandingBuyDrink from "./virtualtips/landing/LandingBuyDrink";
import LandingUserDanceHistory from "./virtualtips/landing/LandingUserDanceHistory";
import LandingUserDrinkHistory from "./virtualtips/landing/LandingUserDrinkHistory";
import LandingUserRewards from "./virtualtips/landing/LandingUserRewards";
import LandingFormCheckoutVT from "./virtualtips/landing/LandingFormCheckoutVT";
import LandingStripePaymentSuccess from "./virtualtips/landing/LandingStripePaymentSuccess";
import LandingFindClub from "./virtualtips/landing/LandingFindClub";
import {AuthKitProvider} from "@workos-inc/authkit-react";
import LandingUserVirtualTipz from "./virtualtips/landing/LandingUserVirtualTipz";
import MuiThemeBridge from "./virtualtips/theme/MuiThemeBridge";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AuthKitProvider
        clientId="client_01JFFS9TSRJWYFHMRWJXPS6F9F"
        apiHostname="api.workos.com"
        devMode={true}
    >
        <MuiThemeBridge>
            <BrowserRouter>
                <Routes>

                    {/*Payments*/}
                    <Route path="/checkout" element={<LandingFormCheckoutVT/>}/>
                    <Route path="/checkout/success" element={<LandingStripePaymentSuccess/>}/>

                    {/*User*/}
                    <Route path="/" element={<App/>}/>
                    <Route path="/find" element={<LandingFindClub/>}/>
                    <Route path="/stage" element={<LandingStage/>}/>

                    <Route path="/user/buy" element={<LandingBuyVT/>}/>
                    <Route path="/user/buy/history" element={<LandingUserBuyVTHistory/>}/>
                    <Route path="/user/tip/history" element={<LandingUserTipHistory/>}/>
                    <Route path="/user/dance/history" element={<LandingUserDanceHistory/>}/>
                    <Route path="/user/drink/history" element={<LandingUserDrinkHistory/>}/>
                    <Route path="/user/code" element={<LandingUserCode/>}/>
                    <Route path="/user/rewards" element={<LandingUserRewards/>}/>
                    <Route path="/user/virtualtipz" element={<LandingUserVirtualTipz/>}/>

                    {/*Admin*/}
                    {/*<Route path="/venue/dashboard" element={<LandingAdminDashboard/>}/>*/}
                    {/*<Route path="/stage/display" element={<LandingStageDisplay/>}/>*/}
                    {/*<Route path="/venue/edit" element={<LandingAdminDashboardEdit/>}/>*/}
                    {/*<Route path="/venue/invoice/details" element={<LandingVenueInvoiceDetails/>}/>*/}

                    {/*/!*Moderator*!/*/}
                    {/*<Route path="/selection" element={<LandingDancerSelections/>}/>*/}

                    {/*/!*EditDancer*!/*/}
                    {/*<Route path="/venue/dancer/edit" element={<LandingAdminDancerEdit/>}/>*/}

                    {/*/!*Sell*!/*/}
                    {/*<Route path="/sell" element={<LandingSellVT/>}/>*/}
                    {/*<Route path="/venue/sell/history" element={<LandingVenueSellVTHistory/>}/>*/}
                    {/*<Route path="/dance/sell" element={<LandingSellDance/>}/>*/}
                    {/*<Route path="/drink/sell" element={<LandingSellDrink/>}/>*/}

                    {/*/!*DancePay*!/*/}
                    <Route path="/dance/buy" element={<LandingBuyDance/>}/>
                    {/*<Route path="/venue/dance/history" element={<LandingVenueDanceHistory/>}/>*/}

                    {/*/!*DrinkPay*!/*/}
                    <Route path="/drink/buy" element={<LandingBuyDrink/>}/>
                    {/*<Route path="/venue/drink/history" element={<LandingVenueDrinkHistory/>}/>*/}

                    {/*/!*Payout*!/*/}
                    {/*<Route path="/payout" element={<LandingDancerPayoutBoard/>}/>*/}
                    {/*<Route path="/venue/tip/history" element={<LandingVenueTipHistory/>}/>*/}

                    {/*/!*PayInvoice*!/*/}
                    {/*<Route path="/venue/invoice" element={<LandingAdminInvoices/>}/>*/}

                    {/*/!*Marketing*!/*/}
                    {/*<Route path="/marketing" element={<MarketingHome/>}/>*/}

                    {/*Other*/}
                    {/*<Route path="/dancer" element={<DancerDashboardLogin/>}/>*/}
                    {/*<Route path="/admin" element={<LoginVenueUser/>}/>*/}
                    {/*<Route path="/signup" element={<Signup/>}/>*/}
                    <Route path="/signup/mobile" element={<SignupMobile/>}/>
                    {/*<Route path="/login" element={<LoginOnboard/>}/>*/}
                    <Route path="/login/mobile" element={<LoginMobile/>}/>
                    {/*<Route path="/login/forgot" element={<ForgotPassword/>}/>*/}
                    {/*<Route path="/admin/forgot" element={<ForgotPasswordVenue/>}/>*/}
                    {/*<Route path="/resetpassword" element={<ResetPassword/>}/>*/}
                    {/*<Route path="/validateemail" element={<ValidateEmail/>}/>*/}
                    {/*<Route path="/validatemobile" element={<ValidateMobile/>}/>*/}
                    <Route path="/terms" element={<Terms/>}/>
                    <Route path="/privacy" element={<Privacy/>}/>
                    <Route path="/legal" element={<Legal/>}/>
                    <Route
                        path="*"
                        element={
                            // <ComingSoon/>
                            <App/>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </MuiThemeBridge>
    </AuthKitProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*

User
{
     "username" : "aaron.king.jr@gmail.com",
     "password" : "1234568",
     "usercode" : "123XYZ"
}

Mod
{
     "username" : "djpartybar",
     "password" : "Meandmom"
}

Admin
{
     "username" : "adminUser",
     "password" : "Meandmom"
}

// Get Add VT working for Flow 1 and calculate profit (charge $520 for 500 VT and app keeps $10 and club gets $10)
Make user tip out for dancers
Get front desk loading VT working and flow!! Need ROLES to only allow certain login to do this and only allow
TIP out for what venue has MADE!!!!! VERY VERY IMPORTANT!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

Page load has like csrf protection for a screen code that only last for a little bit before neededing refresh like
work auth to signin!!!! keeps people without access out!!

// MARKETING MAKES USERS RETURN TO YOUR VENUE!!! OR OTHERS BECAUSE THEY HAVE ALREADY SENT MONEY WITH YOU, LIKE FRONTIER FLY PACKAGES!!

Tip History
User - DONE
Dancer -
Venue -

Purchase History
User - DONE
Venue - DONE

// Get Company Signup Process Working and assign Admin Flow Working and working Admin, Assign admin codes for VT etc... SEE RICHESTIN and flow for that website in my phone
 - Create Venue ( add name, add checkinCode, add image )
 - Add Venue Packages
 - Add Venue Admin Codes for Selling VT (if necessary)
 - Add Accounts (Dj, Payout, Sell, Dancers, Admins)

 ---------------------------------------------------------------

Add ability for weekly invoicing!! and dashboard week view

Display example like stage page
Stage page for the ADMIN!!!!!!!! OR ROLE just for it - ROLE JUST FOR IT that includes admin of course
PureGold
Dancer Name
TIps counter!! WITH SOUND MAYBE???

// VT Pay
Enter VT Amount -> Choose Who / What to Pay -> Click Pay

// Use VT to pay for dances (lap and private)
Choose Dancer -> Choose Type of Dance -> Pay with VT

// Use VT to pay for drinks
Choose Bar -> Choose Type of Drink -> Pay with VT
Choose Bar -> Choose Custom Pay -> Enter VT Amount -> Pay with VT (Like Cash APP)

------------------------------------

// Verify Dancer Create Account Flow

// Verify and test Tipping

// Verify UI look good

// Verify separate DB per Venue??

// Build Docker Containers and Launch!!!

------------------------------------

Read Phone Notes Again and document here

//MAKE SURE THE RIGHT STRIPE ACCOUNT IS WITH THE CORRECT VENUES!!!!!!!

Continue building out flow diagram

Stripper list built when stripper checks in via - Scan code or same process as today and someone adds them to the list

Stripper profile needs ease of creation either by stripper or Dj / Maintainer.
 - USE MOBILE APP FOR IT call VirtualTipz Stripper App Profile!! shows money made etc....
 - Owner needs to approve each girl, so now Stripper has one profile for all the strip clubs and we can advertise to this
   huge list of strippers!!
   - Name
   - ID CODE
   - Email
   - Phone Number
   - List of Club Codes / Clubs
   - Tips Made

VirtualTipz DJ App

FOCUS mainly on Ease of Processes and Stage Tips, and Table Request! and maybe VIP Dances,

// Dancer has to be checkedin to show in selection list, checkout happens when they cash out for the day or auto after a
   certain time of day????

// NO Toggle but have a button to show checked in only!!!!! which shows current selected and checked in only, current selected
   show display at top someWHERE so DJ don't have to scroll AROUND!!

// On Dancer selection add toggle for checkin vs all dancers (all dancers would be like the edit list)

// On Dancer Edit allow moderater to checkin from list or add to list

// TRY and keep dancer stuff simple, easy, straight to the point!!

// Allow Dancer to Scan in and be added to check in list

// TIP / Dance type history list add sort by Dancer!

// Write outflow for a new dancer and existing dancer
   - New Dancer needs to be added to club list by DJ or Admin
   - If dancer has media card from another club can they just scan in???

// Dancer management Portal but think dancers don't span across clubs as far as payout names etc.....!!!

// VERIFY WORK FLOWS ARE EASY AND BUILD WORK FLOW DIAGRAMS PER USER and document

// PERFORMANCE TESTING!!!

// Make sure website is FAST!! or atleast seems fast!!!

// Copyright VirtualTipz Image

// Need resend email verification for auth0 - https://auth0.com/docs/manage-users/user-accounts/resend-verification-emails

// Need Business CashApp Account for VirtualTipx

// Create VirtualTipz Social media All and Youtube Live

// Create - She Goat - La Diosa

// Create LILI Youtube - Lili Live

// Create Austin Cartoon Youtube

// Find Aj Coding Course

// Find Austin Drawing Course

// Print home work for Lili and Austin

Payment In App // Make calucations for how much is paid to Stripe and profits etc.... maybe include stripe payment in profit margins???

------
// Replace current Login with Auth0!!!!
   - Passwordless logins
   - Replace Principal
   - Need to learn how to use Auth0 API to create USERS with claims / roles / permissions
   - Copy AUth code VirtualTipz but fork it and delete out of current project!!!!
   - Need all social media working and SMG passwordless
   - Check to see if I need Twilo or Sendgrid for this!!!!

   Make sure login / signup is 100 in PROD!!
 - verify phone number account and need to subscribe
 - verify validate code etc... is working!!

// Fix remaining sonar and security issues

// Finish ideas from phone

// Look into AWS , GOOGLE tools for Websockets etc....!!! and any other things to make it easier

// Finish buying drinks and dances

// Scan for security!!

// Verify Visual of Stage Tips / Work on Money Shooter but don't allow that to hold me back

// TEST TEST TEST!!!

// Find next seminar

// MARKETING
    - WHY IT MAKES SENSE TO USE VT
    - HOW YOU CAN MAKE MORE MONEY
    - STREAMLINE YOUR CLUB

Go To every club in NC

// SOUND????????

// HOW CLOSE ARE YOU TO NEXT REWARD!!

// PAY THROUGH STRIPE TO GET VT

// PAY OUT THROUGH STRIPE TO EMPLOYEES STRAIGHT TO THEIR ACCOUNT

// VT Live, live stream stripper performance to get tips that way

// VT live users can tip around the world and plan to visit your favorite club

 - Sell accept Drink Coupons
 - User View Drink Coupons and rewards!!
 - Backend code assign coupons based on Rewards STUFF!!! automatic for coupons generatation, reward create screen should allow
   coupon addition!!!
 - Seller assign Drink Coupons Feature

- Free Admission Coupons , different coupon types
- VIP Experience Coupon
- scan these at front desk when reward check is done but see as coupon,
Scan Coupon!!! Choose Type Front Desk Check Rewards | Scan Coupon

- Sell Drink Coupon
- Sell Dance Coupon
- Coupons
 - Drink Coupons
 - Dance Coupons

- Sell Other Dance
 - Add Dance List

- Sell ANy Drink
 - Add Drink selection list

- Need sound on apple device web browser

- Dancer Payout History needs limiter!!

- Add 2 factor login for admin maybe!! or atleast for Sell and Admin roles and mod!!
- Add Phone login for Admin and other Venue Rolls

- Change Table Request to table number input so that dancer can see which table tipped the most and go to that table.
// Spell out that table request are not guarentted
// Show girl which table tipped the most for table request

- It will be a different schedule for invoicing because time zone based off venue

- Need copy text message link meta data to show VT image for texted LINK!!

- Add logging and Test

- Update DEFAULT package descriptions to show how much tips, private dances, and drinks you can BUY!!!!!

- UPDATE DEFAULT TEST DATA AND ENTRY DATA!!!!! FOR VENUE SETUP

- Remove usage of VT and replace with VirutalTipz OR USE VT Every WHERE!!!!

- Add Demo Enterprise / Venue
// Need a slot called demo to stream line demos data
 -- Clear Data only

// Run security scans and sonar and fix ide bugs and any react errors in console

// Make sure no datasturuces get to large
// Database per Venue?? or groups of Venues???
// Have different APP per state running in AWS ???

// Work on online marketing and away to send information to the clubs
// Maybe start youtube channel with funny stripper videos!!!
// See instgram of ED and poleposition

// Q1 Jan - March
 - Finish adding new features
 - Online Marketing for VT
 - Online Marketing for RichestIn

// Q2 Grossing $50K a quarter April - June
 - Visit atleast 50 clubs ( 3 out of 50 so far )

// Q3 Grossing $50K a quarter July - September

// Q4 Grossing $50K a quarter October - December

// Practice Presentation Over and Over and Over again

// 3-4 Clubs per night!!

// Put together Plan with which Clubs I will hit and When
  - Marketing for that Club, pre-add Club to System - in non-prod DB.
  - Make Map of the money I will get per club based off their current Revenue.
  - See if they are owned by Franchise and who the big dog is for it.

// Finish Marketing Material for VT, make it all positive and hit all key points
  - No change in your financial system
  - You control the money
  - Customers pay and nothing comes out your pocket, only gains for you and your dancers

// Order VT Table Stickers

// Order VT Poster sign for Venue Code

// Create Website to SELL RichestIn Database

// ReLaunch RichestIn
 -- Change the way the payments look, don't switch APPS
 -- Marketing - Start youtube with money videos and copy what that girl on my FB is doing as far as language

// ReLaunch LastLatterKnockout

-------------------------------------
// V2 - Check Rewards needs user input screen for checks!!

// V2 - Need configurable tip sound for tips and have venue feature flag for TIp sound and for venue stage display sound

// V2 - Integrate Payment system through the APP!!

// V2 - ADD IN ABILITY TO LEAVE TIP TO BARTENDERS!! THROUGH APP like DANCERS. Have bars labelled like BAR 1 etc... and names or Tenders

// V2 - TIp track so people can compete on tips and see the biggest tips

// V2 - Show Dance History in Dancer History

// V2 - Dancer can set tip goal to try and reach goal per dance

// V2 - Make sure no datasturuces get to large

// V2 - Think about how to archive Sell History so that it doesn't get to large!!! store in files or something on my own cloud harddrive (reduce cost)

// V2 - Allow admin to add codes

// V2 - In test create invoice loop through all venues to create all invoices

// V2 Feature - Add other quick signup methods

// V2 Feature - Need better tips affect on whole page for mobile to see it

// V2 Feature - Allow Dancer Pin Update

// V2 Feature - Break Admin Menu down into more selections / break up dashboard

// V2 Feature - Other money amounts

// V2 Feature - Users see VT available across venues???? UI

// V2 Feature - Add Feature Voting Comp!! and betting of VT

// V2 Feature - OR break it down to have different buttons to tip different amounts!!! like 1 - 5 - 15 - 20 All have different sounds

// V2 Feature - Get Add VT working for Flow 2
WOrk on other flow where BUY THROUGH APP!!!!!
Opens up shared VT across venues and percentage getting off each tip, no need in payment system, just need to support VT

// V2 Feature - Add Comp for the Night and whomever wins gets free VT etc.... see phone notes
 */